module.exports = __webpack_public_path__ + "static/img/bcg.873344b0.webp";